import React from 'react';

import QuotaZonal  from 'components/Tvendo/Sale/QuotaBPartner/Clorox/QuotaZonalClorox/List.js';

export default function () {
  return <QuotaZonal  />;
}